import React, { useState, useEffect, useRef } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"

const APPLY_URL = "https://inpowered.applytojob.com/apply"
const SCROLL_OFFSET = 88

export default function OpenPositions({ jobs = [] }) {
  const [openId, setOpenId] = useState(null)
  const [animationState, setAnimationState] = useState({})
  const itemRefs = useRef(new Map())

  const toggle = id => {
    if (openId === id) {
      setAnimationState(prev => ({ ...prev, [id]: "exiting" }))
      setTimeout(() => {
        setOpenId(null)
        setAnimationState(prev => ({ ...prev, [id]: "closed" }))
      }, 300)
    } else {
      setOpenId(id)
      setAnimationState(prev => ({ ...prev, [id]: "entering" }))
      setTimeout(() => {
        setAnimationState(prev => ({ ...prev, [id]: "open" }))
      }, 50)
    }
  }

  useEffect(() => {
    if (!openId) return
    const el = itemRefs.current.get(openId)
    if (!el) return
    // wait a tick so the opening class is applied, then scroll to the item head
    requestAnimationFrame(() => {
      const y =
        el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET
      window.scrollTo({ top: y, behavior: "smooth" })
    })
  }, [openId])

  return (
    <section
      className="open-positions section"
      id="open-roles"
      style={{ minHeight: "330px" }}
    >
      <div className="container p-5">
        <div
          className="columns is-variable is-6 open-positions-container"
          style={{ gap: "120px" }}
        >
          <div className="column is-3">
            <h1 className="title is-1 has-text-purple nowrap is-size-3-mobile">
              Open Positions
            </h1>
          </div>

          <div className="column is-9" style={{ maxWidth: "820px" }}>
            <ul className="open-positions mt-3">
              {jobs.map(job => {
                const applyButton = (
                  <a
                    href={`${APPLY_URL}/${job.id}`}
                    className="button is-link is-rounded px-6 mt-6 mb-4 is-size-6 has-text-weight-medium"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Apply Here
                  </a>
                )
                const location = [job.city, job.state]
                  .filter(Boolean)
                  .join(", ")
                const isOpen = openId === job.id
                const currentAnimationState = animationState[job.id] || "closed"

                return (
                  <li
                    key={job.id}
                    ref={el => el && itemRefs.current.set(job.id, el)}
                    className={`position-row${isOpen ? " is-open" : ""}`}
                  >
                    <button
                      className="position-head mt-3"
                      onClick={() => toggle(job.id)}
                      aria-expanded={isOpen}
                      aria-controls={`job-panel-${job.id}`}
                    >
                      <span className="position-title has-text-purple is-size-5-desktop has-text-weight-semibold is-size-5-mobile">
                        {job.title}
                        {location && (
                          <span className="position-location has-text-weight-light is-size-5-desktop">
                            , {location}
                          </span>
                        )}
                      </span>
                      <span
                        className={`chevron${isOpen ? " is-open" : ""}`}
                        aria-hidden="true"
                      >
                        <FontAwesomeIcon icon={faChevronDown} />
                      </span>
                    </button>

                    <div
                      id={`job-panel-${job.id}`}
                      className={`position-panel${
                        isOpen ? " is-open" : ""
                      } ${currentAnimationState}`}
                      role="region"
                    >
                      {(isOpen || currentAnimationState === "exiting") && (
                        <div
                          className={`content has-text-purple job-desc py-5 ${currentAnimationState}`}
                        >
                          <div>
                            <div
                              className="mb-4 has-text-purple"
                              dangerouslySetInnerHTML={{
                                __html: job.description,
                              }}
                            />
                            {applyButton}
                          </div>
                        </div>
                      )}
                    </div>

                    <hr className="divider" />
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
